import cz from '../csCZ/help';

const en: typeof cz = {
	search_title:
		'Help for searching in the Digitální archiv application (Digital archive) ',
	search_text_prefix:
		'The application enables to search information about persons and houses in the Brno Digital archive. Searching is possible via two levels that allow to seek information in the Digital archive.',
	search_text_bold: '',
	search_text_suffix: '',
	basic_search_title: 'Basic searching',
	basic_search_text: 'Possible to search according to:',
	metadata: {
		year: 'Census year',
		street: 'Street name',
		house: 'House number',
		surname: 'Surname',
		firstname: 'First name',
	},
	search_in_connected_municipalities_title:
		'Searching in connected towns and villages ',
	search_in_connected_municipalities_prefix:
		'In case of searching in a town or village connected to Brno in 1919, it is necessary to fill the Czech name of the town or village in the ',
	search_in_connected_municipalities_bold: 'Street name',
	search_in_connected_municipalities_suffix:
		' column. The names of the streets will be offered after typing Czech name of the town or village (e. g. Královo Pole, Husovice etc.). As the indexes were never made for these connected towns and villages it is not possible to search via name or surname there. Therefore, it is necessary in the whole street of the town or village successively.',
	advanced_search_title: 'Advanced search',
	advanced_search_text:
		'System of advanced searching is used mainly by archivists and researchers with experience.',
	advanced_search_criteria: {
		text: 'Possible to search according to: ',
		volume: 'Volume – indication of individual volume of name index',
		page_number:
			'Page number – number of page in the book where the searched name occurs',
		inventory_number:
			'Inventory number – unique data entry for each book both from name registers and census records',
	},
	search_results_title: 'Search results',
	search_results_text:
		'The results are available in the chart according to the inserted criteria. There are columns like census year, street name, house number, picture of records, surname, name and index page item-by-item in each row. The census sheet or index record can be visible after clicking on magnifier icon.',
	archive_view_title: 'Display of archives',
	archive_view_text:
		'There is information about seeked person in the heading of the displayed archives. There are also functions for magnifying or reducing the sheet, displaying preview, 90 degrees rotating, returning to the previous screen and browsing in pages of the archives.',
};

export default en;
